// extracted by mini-css-extract-plugin
export default {"div":"Weather_div__ShJcR"};